import { render, staticRenderFns } from "./StudioSimpleContentPreview.vue?vue&type=template&id=caec5096&scoped=true&"
import script from "./StudioSimpleContentPreview.vue?vue&type=script&lang=js&"
export * from "./StudioSimpleContentPreview.vue?vue&type=script&lang=js&"
import style0 from "./StudioSimpleContentPreview.vue?vue&type=style&index=0&id=caec5096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caec5096",
  null
  
)

export default component.exports